import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { paths } from "../../paths/paths";

const AgendaCard = ({ agenda, onEdit, onDelete }) => {
  const ThreeDotsToggle = React.forwardRef(({ onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="d-flex justify-content-center align-items-center"
      style={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        cursor: "pointer",
      }}
    >
      <Icon name="ellipsis-v" size={18} color="#6c757d" />
    </div>
  ));

  ThreeDotsToggle.displayName = "ThreeDotsToggle";

  const formatDate = (date) => {
    if (!date) return "";

    return new Intl.DateTimeFormat("ar-EG", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(date));
  };

  return (
    <div
      className="card shadow-sm mb-4"
      style={{
        borderRadius: 12,
        border: "1px solid #e5e5e5",
      }}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start">
          <h5 className="fw-bold mb-0">{agenda.title}</h5>

          <Dropdown align="end">
            <Dropdown.Toggle as={ThreeDotsToggle} />

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => onEdit(agenda)}>
                <FontAwesomeIcon icon={faPen} className="mx-2" />
                تعديل
              </Dropdown.Item>

              <Dropdown.Item
                className="text-danger"
                onClick={() => onDelete(agenda)}
              >
                <FontAwesomeIcon icon={faTrash} className="mx-2" />
                حذف
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="my-2">
          <div className="d-flex flex-wrap align-items-center gap-4">
            <div>
              نوع الفعالية :
              <span className="badge text-dark rounded-pill bg-light ms-1">
                {agenda.planned ? "مخطط" : "غير مخطط"}
              </span>
            </div>
            <div>
              نوع الحضور :
              <span className="badge text-dark rounded-pill bg-light ms-1">
                {agenda.attend ? "فعلي " : "افتراضى"}
              </span>
            </div>

            {agenda.communityId && (
              <div>
                المحور:
                <span className="badge text-dark rounded-pill bg-light ms-1">
                  {agenda.communityName}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="row gy-3">
          <div className="col-md-2">
            <div className="text-muted">تاريخ البداية</div>
            <div className="fw-bold">{formatDate(agenda.registerDate)}</div>
          </div>
          <div className="col-md-2">
            <div className="text-muted">تاريخ النهاية</div>
            <div className="fw-bold">{formatDate(agenda.endDate)}</div>
          </div>

          <div className="col-md-12">
            <div className="text-muted mb-2">المرفقات</div>

            {agenda.attchment?.length > 0 ? (
              <div className="d-flex  gap-2">
                {agenda.attchment.map((file) => (
                  <a
                    key={file.id}
                    href={`${paths.Agenda}${agenda.id}/${file.attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark d-flex gap-2"
                  >
                    <Icon name="paperclip" size={14} />
                    <span className="mx-2">{file.attachment}</span>
                  </a>
                ))}
              </div>
            ) : (
              <span className="text-muted">لا يوجد</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgendaCard;
